import React, { useState, useEffect } from 'react'
import { Avatar, Dropdown } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { AUTH_CHANGE_EVENT, clearAuthSession } from '../../utils/auth'
import ChangePasswordModal from '../ChangePasswordModal'
import styles from './index.module.css'

const NAV_ITEMS = [
    { path: '/chinese-seg',        label: '中文分词' },
    // { path: '/english-seg', label: '英文分词' },
    { path: '/wordcloud',          label: '词云分析' },
    { path: '/sentiment',          label: '评论分析' },
    { path: '/english-correction', label: '英语作文批改' },
    // { path: '/topic',      label: '主题分析' },
]

const CommonHeader = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'))
    const [username, setUsername] = useState(localStorage.getItem('username') || '用户')
    const [isAdmin, setIsAdmin] = useState(localStorage.getItem('is_admin') === 'true')
    const [changePasswordOpen, setChangePasswordOpen] = useState(false)

    useEffect(() => {
        const syncAuthInfo = () => {
            setIsLoggedIn(!!localStorage.getItem('token'))
            setUsername(localStorage.getItem('username') || '用户')
            setIsAdmin(localStorage.getItem('is_admin') === 'true')
        }
        window.addEventListener(AUTH_CHANGE_EVENT, syncAuthInfo)
        window.addEventListener('storage', syncAuthInfo)
        return () => {
            window.removeEventListener(AUTH_CHANGE_EVENT, syncAuthInfo)
            window.removeEventListener('storage', syncAuthInfo)
        }
    }, [])

    const logout = () => {
        clearAuthSession()
        navigate('/login')
    }

    const handleMenuClick = ({ key }) => {
        if (key === 'change-password') {
            setChangePasswordOpen(true)
            return
        }

        if (key === 'generate-account') {
            navigate('/generate-account')
            return
        }

        if (key === 'logout') {
            logout()
        }
    }

    const menuItems = [
        {
            key: 'change-password',
            label: <span>修改密码</span>,
        },
        ...(isAdmin ? [{
            key: 'generate-account',
            label: <span>生成账户</span>,
        }] : []),
        {
            key: 'logout',
            label: <span>退出登录</span>,
        },
    ]

    return (
        <header className={`${styles.header_container} ${!isLoggedIn ? styles.header_centered : ''}`}>
            {/* 左侧占位，保持中间居中 */}
            {isLoggedIn && <div className={styles.side_placeholder} />}

            {/* 中间：logo + tabs */}
            <div className={styles.center_group}>
                <div className={styles.logo}>
                    <span className={styles.logo_shimmer}>百发百中</span>
                </div>
                <div className={styles.divider} />
                <nav className={styles.nav}>
                    {NAV_ITEMS.map(item => (
                        <div
                            key={item.path}
                            className={`${styles.nav_item} ${location.pathname === item.path ? styles.nav_item_active : ''}`}
                            onClick={() => navigate(item.path)}
                        >
                            {item.label}
                        </div>
                    ))}
                </nav>
            </div>

            {/* 右侧用户区 */}
            {isLoggedIn && (
                <div className={styles.user_area}>
                    <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }}>
                        <div className={styles.user_info}>
                            <Avatar size={32} src={require('../../assets/images/user.jpg')} />
                            <span className={styles.username}>{username}</span>
                        </div>
                    </Dropdown>
                </div>
            )}

            <ChangePasswordModal
                open={changePasswordOpen}
                onClose={() => setChangePasswordOpen(false)}
            />
        </header>
    )
}

export default CommonHeader
